import {MDCSelect} from "@material/select";

$.fn.dataArray = function( name ) {
  return this.map( function( i, element ) {
      return $(element).data( name );
  });
};

var notificationTimer;
window.showEditShowCaseNotification = function(type, alert_class = 'success', timeout = 3000) {
  let alert = $(`.alert-${alert_class}`)
  if (alert[0] == undefined) return false

  let text = ''
  if(type == 'update') {
    text = 'Your <b>campaign</b> was successfully updated.'
  } else if(type == 'share') {
    text = 'Link copied!'
  } else if(type == 'disabled'){
    text = 'Action disabled until kickoff'
  } else {
    text = type;
  }
  alert.find('span').html(text);
  alert.css('display', 'flex');
  alert[0].classList.add('animate__animated', 'animate__bounceIn');
  clearTimeout(notificationTimer);
  notificationTimer = 0;
  notificationTimer = setTimeout(function() {
    alert.css('display', 'none');
    alert[0].classList.remove('animate__animated', 'animate__bounceIn');
  }, timeout)
  notify = false;
}

window.showNoticeModal = function() {
  let modal = $(document).find('.edit-show-case-modal');
  let notice = modal.find('.edit-show-case-content');
  modal.css('display', 'flex');
  notice.css('display', 'flex');
  iframe = modal[0].getElementsByTagName("iframe")[0].contentWindow;
  iframe.postMessage('{"method":"play"}', '*');
  // notice_timer = setTimeout(function() {
  //   $(document).find('.edit-show-case-modal').css('display', 'none');
  // }, 10000)
}


window.showWinVideoModal = function() {
  let winVideoModal = $("#win_video_modal_edit_showcase")
  if (winVideoModal){
    winVideoModal.show()
    winVideoModal.css('display', 'block')
  }
}

window.showCarryContact = function() {
  let contactsModal = $("#carry-contacts-modal")
  if (contactsModal){
    contactsModal.show()
    contactsModal.css('display', 'block')
  }
}

$(window).on('click', function (event) {
  let winVideoModal = $("#win_video_modal_edit_showcase")
  if (event.target === winVideoModal.get(0)) {
    winVideoModal.hide()
  }
})

$(document).on('turbolinks:load', function() {
  const resizeObserver = new ResizeObserver((entries) => {
    $(document).find('.destination-height-el').height($(document).find('.source-height-el').height());
  })

  if (!(typeof notify === 'undefined')) {
    if(notify) {
      showEditShowCaseNotification(notify_text, notify_class, 6000);
    }
  }

  $(document).find('.share-trigger-edit_showcase').on('click', function(e){
    e.preventDefault();
  });

  if(document.getElementById("pitche-root-element")) {
    resizeObserver.observe(document.getElementById("pitche-root-element"));
  }

  $(document).find('.upload-container').on('click', function(e){
    let input = $(this).next();
    input.trigger('click');
  });

  $(document).find('#change-video-trigger').on('click', function(e){
    // MVT Slice 6 (T-S6-WS5-04): when the MVT is on the WiddyUP replace
    // control navigates to the dedicated trim page instead of the legacy input
    // (which is not rendered on the trim path).
    let trimUrl = $(this).data('trim-url');
    if (trimUrl) {
      window.location.href = trimUrl;
      return;
    }
    let input = $(this).parent().parent().prev().find('input');
    input.trigger('click');
  });

  $('#delete-video-trigger').on('click', function(e){
    $(document.body).css('overflow', 'hidden')
    $('#remove-final-video-dialog').css('display', 'block')
  });

  $(document).find('.dialog-close').on('click', function(e){
    $(document.body).css('overflow', 'auto')
    $('#remove-final-video-dialog').css('display', 'none')
  });

  $(window).on('click', function (event) {
    let deleteVideoDialog = $('#remove-final-video-dialog')
    if (event.target === deleteVideoDialog.get(0)) {
      $(document.body).css('overflow', 'auto')
      deleteVideoDialog.css('display', 'none')
    }
  })

  $('#delete-pitch-trigger').on('click', function(e){
    $(document.body).css('overflow', 'hidden')
    $('#remove-pitch-video-dialog').css('display', 'block')
  });

  $(document).find('.dialog-close').on('click', function(e){
    $(document.body).css('overflow', 'auto')
    $('#remove-pitch-video-dialog').css('display', 'none')
  });

  $(window).on('click', function (event) {
    let deleteVideoDialog = $('#remove-pitch-video-dialog')
    if (event.target === deleteVideoDialog.get(0)) {
      $(document.body).css('overflow', 'auto')
      deleteVideoDialog.css('display', 'none')
    }
  })

  $(document).on('click', '[data-element-type="remove-final-video"]', function () {
    let button = $(this)
    let studentId = $(this).attr('data-student-id');
    let pitchId = $(this).attr('data-pitch-id');
    button.prop('disabled', true)
    button.addClass('btn-disabled')
    button.removeClass('v2-btn-blue')
    button.text("Please wait...")
    Rails.ajax({
      type: "DELETE",
      url: `/v2/students/${studentId}/pitches/${pitchId}/remove_final_video`,
      success: (response) => {
        display_alert(response['message'], 'success')
        setTimeout(function (){
          location.reload()
        }, 1000)
      }
    })
  })

  $(document).on('click', '[data-element-type="remove-pitch-video"]', function () {
    let button = $(this)
    let studentId = $(this).attr('data-student-id');
    let pitchId = $(this).attr('data-pitch-id');
    button.prop('disabled', true)
    button.addClass('btn-disabled')
    button.removeClass('v2-btn-blue')
    button.text("Please wait...")
    Rails.ajax({
      type: "DELETE",
      url: `/v2/students/${studentId}/pitches/${pitchId}/delete_pitch_video`,
      success: (response) => {
        display_alert(response['message'], 'success')
        setTimeout(function (){
          location.reload()
        }, 1000)
      }
    })
  })

  $(document).find('.video-file-input-trigger').on('change', function(e){
    let form = $(document).find('.edit-show-case-form');
    let modal = $(this).parents('.pitches-root').find('.upload-video-modal');
    let content = modal.find('.upload-video-content');
    modal.css('display', 'flex');
    content.css('display', 'flex');
    form.trigger('submit');
    $(document).find('.video-tag').each(function() {
      this.pause();
      this.currentTime = 0;
    });
    $('#pitch-modal').removeClass('open');
  });

  $(document).find('.use-standard-pitch').on('click', function(e){
    e.stopPropagation();
    var media = $(document).find('.video-tag.modal1').get(0);
    media.pause();
    media.currentTime = 0;
    let standardPitch = $('#pitch_standard_pitch');
    standardPitch.val(true);
  });

  $('#create-your-own-video').on('click', function(e){
    $('#standard-pitch-upload').hide();
  });

  $(document).find('.pitch-video-file-input').on('change', function(e){
    $(document).find('.video-tag').each(function() {
      this.pause();
      this.currentTime = 0;
    });
    let standardPitch = $('#pitch_standard_pitch');
    standardPitch.val(false);
    $('#pitch-modal').removeClass('open');
    let form = $(document).find('.edit-show-case-form');
    let modal = $(this).parents('.pitches-root').find('.upload-pitch-video-modal');
    let content = modal.find('.upload-video-content');
    modal.css('display', 'flex');
    content.css('display', 'flex');
    form.trigger('submit');
  });

  $(document).find('#own-pitch-footer').on('click', function(e){
    e.preventDefault();
    var media = $(document).find('.video-tag.modal1').get(0);
    media.pause();
    media.currentTime = 0;
    $('#standard-pitch-upload, #use-standard-pitch-footer ,#own-pitch-footer').fadeOut();
    setTimeout(function() {
      $('#create-your-own, .prev-link, .back-svg').fadeIn();
    }, 400)
    $('#pitch-modal').animate({
      scrollTop: $('.pitch-modal-header').offset().top - 2000
    }, 'slow');
  });

  $('.go-back').on('click', function(e) {
    $('#upload-standard-pitch-footer, #create-your-own, .prev-link, .back-svg').hide();
    $('#standard-pitch-upload, #upload-pitch-header, #use-standard-pitch-footer, #own-pitch-footer').show();
    $('.video-info').show();
    $('#pitch-modal').animate({
      scrollTop: $('.pitch-modal-header').offset().top - 1000
  }, 'slow');
  });

  $('#upload-pitch, #pitch-change-video-trigger').on('click', function(e) {
    $('#upload-standard-pitch-footer, #create-your-own, .prev-link, .back-svg').hide();
    $('#standard-pitch-upload, #upload-pitch-header, #use-standard-pitch-footer, #own-pitch-footer').show();
    $('.video-info').show();
    $('#pitch-modal').addClass('open');
  });

  $('#close-pitch-modal').on('click', function(e) {
    $(document).find('.video-tag').each(function() {
      this.pause();
      this.currentTime = 0;
    });
    $('#pitch-modal').removeClass('open');
  });

  $(document).find('.learn-more-about-pitch-video').on('click', function(e){
    let modal = $(document).find('.how-to-pitch-video-modal');
    let notice = modal.find('.edit-show-case-content');
    modal.css('display', 'flex');
    notice.css('display', 'flex');
    var media = $(document).find('.video-tag.how-to-pitch').get(0);
    media.currentTime = 0;
    media.play();
    $(".video-info").hide();
  });

  $(document).find('.video-tag.how-to-pitch').on('ended',function() {
    $(".close-how-to-pitch").trigger("click");
  });

  $(document).find('.close-how-to-pitch').on('click', function(e){
    var media = $(document).find('.video-tag.how-to-pitch').get(0);
    media.pause();
    media.currentTime = 0;
    $(".video-info").hide();
    let modal = $(document).find('.how-to-pitch-video-modal');
    let notice = modal.find('.edit-show-case-content');
    modal.fadeOut();
  });

  $(document).find('.video').on('click', function () {
    var video = $(this).children().children().get(0);
    if (video.paused) {
      video.play();
      $(".video-info").hide();
    } else {
      video.pause();
      $(".video-info").show();
    }
  });

  $(document).find('.video-tag').on('ended',function() {
    $(this).get(0).currentTime = 0;
    $(this).parent().parent().children().last().show();
  });

  $(document).find('.edit-show-case-button-trigger').on('click', function(e){
    let form = $(document).find('.edit-show-case-form');
    form.trigger('submit');
  });

  $(document).find('#fundraiser_cancel_button').on('click', function(e){
    let form = $(document).find('.edit-show-case-form');
    form.trigger('reset');
    let footer = $(document).find('.showcase-footer');
    footer.css('display', 'none');
    footer[0].classList.remove('animate__animated', 'animate__bounceInUp');
  });

  $(document).find('.video-tag-button').on('click', function(e){
    let modal = $(this).parents('.pitches-root').find('.tags-modal');
    let tags = modal.find('.tags-content');
    modal.css('display', 'flex');
    tags.css('display', 'flex');
  });

  $(document).find('.close-tags-modal-trigger').on('click', function(e){
    $(this).parents('.tags-modal').css('display', 'none');
  });

  $(document).find('.tag-item').on('click', function(e){
    let current = $(this)
    let selected = current.parent().find('.selected');
    if(current.hasClass('selected')) {
      current.removeClass('selected');
      return null;
    }
    if (selected.length >= 3) return null;

    current.addClass('selected');
  });

  $(document).find('.done-tags-modal-trigger').on('click', function(e){
    let url = window.location.href;
    let full_url = `${url}/update_tags`
    let list = $(this).parents('.tags-modal').find('.tag-list');
    let selected = list.find('.selected');
    let data_array = selected.dataArray('info');
    let videoId = list.data('video-id');
    let pitchId = list.data('pitch-id');
    let body = {
      final_pitch_video: { talent_ids: data_array.toArray() },
      final_pitch_video_id: videoId,
      id: pitchId
    }
    if(data_array.length > 0) {
      $.ajax({
        type: 'POST',
        url: full_url,
        dataType: 'json',
        data: body,
        success: (data) => {
          $(this).parents('.tags-modal').css('display', 'none');
          showEditShowCaseNotification('update');
        }
      });
    }
  });

  var timer;
  $(document).find('.stepper-item').on('click', function(e){
    let element_selector =  $(this).data('target');
    $(document).find(`.${element_selector}`).get(0).scrollIntoView({
      behavior: 'auto',
      block: 'center',
      inline: 'center'
    });
    $(document).find('.form-body-headline').removeClass('hightlited');
    $(document).find('.video-card-pitch').removeClass('hightlited');
    $(document).find('.video-card-widdyup').removeClass('hightlited');
    $(document).find('.sharing-cta').removeClass('hightlited');
    $(document).find(`.${element_selector}`).addClass('hightlited');
    clearTimeout(timer);
    timer = setTimeout(function() {
      $(document).find(`.${element_selector}`).removeClass('hightlited');
    }, 2500)
  });

  $(document).find('.copy-link').on('click', function(e) {
    e.preventDefault();
    showEditShowCaseNotification('share');
  });

  $(document).find('.copy-link-disabled').on('click', function(e) {
    e.preventDefault();
    showEditShowCaseNotification('disabled');
  });

  $(document).find('.done-edit-show-case').on('click', function(e){
    let modal = $(this).parents('.edit-show-case-modal');
    let iframe = modal[0].getElementsByTagName("iframe")[0].contentWindow;
    iframe.postMessage('{"method":"pause"}', '*');
    modal.css('display', 'none');
  });


  $(document).find('.welcome-cta-trigger').on('click', function(e){
    showOnboardingWizard();
  });

  $(document).find('.input-trigger-change').on('input', function(e){
    let footer = $(document).find('.showcase-footer');
    footer.css('display', 'flex');
    footer[0].classList.add('animate__animated', 'animate__bounceInUp');
  });

  const pitchCategoriesElement = document.querySelector('.pitch-categories');
  if (pitchCategoriesElement) {
    const selectElements = pitchCategoriesElement.querySelectorAll('.mdc-select');

    selectElements.forEach(selectElement => {
      const mdcSelect = new MDCSelect(selectElement);

      mdcSelect.listen('MDCSelect:change', () => {
        const footer = $(document).find('.showcase-footer');
        footer.css('display', 'flex');
        footer[0].classList.add('animate__animated', 'animate__bounceInUp');
      });
      console.log(mdcSelect.value);
      if (!mdcSelect.value) {
        mdcSelect.valid = false; // Set the MDCSelect component to invalid
      } else {
        mdcSelect.valid = true; // Set the MDCSelect component to valid
      }
    });
  }

  function set_background_for_edit_campaign(){
    setTimeout(function() {
      if ( $(".form-body-video").length > 0 ) {
        $(".background").height($(".video-card-pitch").offset().top+50)
      }
    }, 100);
  }

  $(document).ready(set_background_for_edit_campaign);
  $(window).resize(set_background_for_edit_campaign);
});

function display_alert(message, type) {
  let alert = $(`#pitche-root-element .alert-${type}`)

  alert.find('span').html(message)
  alert.css('display', 'flex')
  alert[0].classList.add('animate__animated', 'animate__bounceIn');

  setTimeout(function () {
    alert.css('display', 'none');
    alert[0].classList.remove('animate__animated', 'animate__bounceIn');
  }, 3000)
}

window.showContactShareModal = function () {
  setTimeout(function() {
    $(document.body).css('overflow', 'hidden')
    $('#contacts-share-modal').css('display', 'block')
  }, 100);
}
